import React, { memo } from "react";
import classNames from "classnames";

import "./SideMenuStraps.style.scss";
import { useMainContext } from "../../../store/Context";
import { useSideMenu } from "../../sideMenu.context";
import { FormattedMessage } from "react-intl";

const SideMenuStraps = () => {
  const { straps, setStrap } = useMainContext();
  const { setOpen } = useSideMenu();

  const handlerSetStrap = (id) => {
    setStrap(id);
    setOpen(false);
  };
  
  return (
    <div className="SideMenuStraps">
      <div className="SideMenuStraps-Title">
        <p>
          <FormattedMessage id="App.strapList" />
        </p>
      </div>
      <div className="SideMenuStraps-List">
        {straps.map(({ id, color, images, stock }) => {
          const classes = classNames('SideMenuStraps-List-WrapItem', {
            disabled: !stock,
          });
          const classesItem = classNames('SideMenuStraps-List-Item', {
            disabled: !stock,
          });
          const props = !stock ? {} : { onClick: () => handlerSetStrap(id) };

          return (
            <div key={id} className={classes}>
              <div
                {...props}
                className={classesItem}
              >
                <img
                  alt={`strap - ${color}`}
                  src={Object.entries(images[0])
                    .pop()
                    .pop()}
                />
                <p>{color}</p>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default memo(SideMenuStraps);
